// extracted by mini-css-extract-plugin
module.exports = {"loading":"App_loading__wCN4P","prerendered":"App_prerendered__-ltQq"};